export default {
  '/': 'Home',
  '/about': 'About',
//
  '/price': 'Hprice',
  '/qty': 'Hdqty',
  '/type': 'Htype',
//
  '/detail': 'Detail'
}







// WEBPACK FOOTER //
// ./src/routes.js